import * as React from "react";
const CheckStatIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={57}
    height={58}
    fill="none"
    {...props}
  >
    <g clipPath="url(#a)">
      <path
        fill="#CAFFC7"
        d="M56.145 28.638c0-15.464-12.536-28-28-28-15.463 0-28 12.536-28 28s12.537 28 28 28c15.464 0 28-12.536 28-28Z"
      />
    </g>
    <path
      fill="#2BC155"
      stroke="#CAFFC7"
      d="M40.685 18.083a1.52 1.52 0 0 1 2.15 2.15l-17.51 17.51a1.52 1.52 0 0 1-2.15 0l-9.428-9.429a1.52 1.52 0 0 1 2.15-2.15l8 8 .353.354 16.435-16.435Z"
    />
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M.146.138h56v57h-56z" />
      </clipPath>
    </defs>
  </svg>
);
export default CheckStatIcon;
